import Beam from './lib/Beam';

document.addEventListener('DOMContentLoaded', () => {
	window.$$beam = new Beam(window.$$beamConfig);
});
